(function (angular) {
	'use strict';

	angular.module('waitlistModule', [
		'BaseConfig',
		'localStorageModule',
		'urlModule'
	]);
})(window.angular);